<template>
  <div class="modal-wrapper">
    <BasicModal
      :title="'CSVインポート/エクスポート 使い方'"
      :canCancel="true"
      :isShowModal=isShowModal
      @cancel="cancel">
      <div class="accordion-container">
        <div class="top-description">
          <p>
            <b>はじめに</b><br>
            まずはミニロボを作成し、試しに共通変数を作成をしてください。
            作成後、エクスポートしたデータを編集し、インポートすることで、
            安全に操作が行えます。
          </p>
        </div>
        <section class="accordion-wrapper">
          <b-collapse
            class="card"
            animation="slide"
            v-for="(collapse, index) of collapses"
            :key="index"
            :open="isOpen == index"
            @open="isOpen = index">
            <div
              slot="trigger"
              slot-scope="props"
              class="card-header"
              role="button">
              <p class="card-header-title">
                {{ collapse.title }}
              </p>
              <a class="card-header-icon">
                <b-icon
                  :icon="props.open ? 'menu-down' : 'menu-up'">
                </b-icon>
              </a>
            </div>
            <div class="card-content">
              <div class="content" v-html="collapse.text"></div>
            </div>
          </b-collapse>
        </section>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'

export default {
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    const collapses = [
      {
        title: 'インポートについて',
        text: '\
          「変数一覧をCSVインポート」ボタンから行えます。<br>\
          CSVファイルを選んでインポートしましょう。<br>\
        '
      },
      {
        title: 'インポート：CSVヘッダー名称について',
        text: '\
          ヘッダー（行番号：１）は1列目にミニロボ名、2列目にミニロボID、3列目にミニロボURLとなります。<br>\
          ミニロボを新規追加したい場合は2列目に「NEW」と記入してください。<br>\
          4列目以降は共通変数名を変更、追加ができます。<br>\
          名前の最初と最後を$で囲うようにしてください。\
        '
      },
      {
        title: 'インポート：CSVデータ内容について',
        text: '\
          4列目の2行目以降は共通変数名に沿ったデータ内容を入力できます。<br>\
          文言タイプの場合はデータ内容の最初に[文言]<br>\
          日程調整タイプの場合はデータ内容の最初に[日程調整]<br>\
          を入力してください。<br>\
          例：[文言]テスト株式会社<br>\
          また、日程調整データについては該当メンバーのEmailを入力してください。<br>\
          複数人いる場合は空白区切りで入れてください。\
        '
      },
      {
        title: 'インポート時のエラーメッセージ一覧',
        text: '\
          <span class="-left-8px">\
            ・何も入力されていないかCSVデータが不正です。\
          </span>\
          <br>\
          <span class="-left-8px">\
            ・変数名が不正です。\
          </span>\
          <br>\
          <span class="-left-8px">\
            ・ミニロボ名が重複している、もしくは名前の値が不正です。\
          </span>\
          <br>\
          <span class="-left-8px">\
            ・ミニロボID値が不正です。\
          </span>\
          <br>\
          <span class="-left-8px">\
            ・[日程調整]のデータ値が不正です。\
          </span>\
          <br>\
          <span class="-left-8px">\
            ・[日程調整]のメールアドレスが不正です。\
          </span>\
          <br>\
          <span class="-left-8px">\
            ・データ値の前にタイプを入力してください。※[文言], [日程調整]など\
          </span>\
          <br>\
          <span class="-left-8px">\
            ・列番号：１の変数名の不正がないか確認をお願い致します。（重複等）\
          </span>\
          <br>\
          <span class="-left-8px">\
            ・サーバーエラーによりデータが正しく保存できませんでした。\
          </span>\
        '
      },
      {
        title: 'エクスポートについて',
        text: '「変数一覧をCSVエクスポート」ボタンから行えます。<br>カンマ区切りのデータが出力されます。'
      },
    ]
    return {
      collapses: collapses,
      isOpen: -1,
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-wrapper {
  .accordion-container {
    padding: 16px;
  }
  .accordion-wrapper {
    height: 480px;
    padding: 8px;
    overflow: auto;
  }
  .top-description {
    margin-bottom: 16px;
    text-align: left;
    font-size: 14px;
  }
  .card-header-title {
    font-size: 12px;
  }
  .card-content {
    .content {
      text-align: left;
      font-size: 12px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/ModalHowToUseCSV.vue